import { render } from "./ReturnsToInventory.vue?vue&type=template&id=1127b110"
import script from "./ReturnsToInventory.vue?vue&type=script&lang=js"
export * from "./ReturnsToInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__